import { render, staticRenderFns } from "./accp-detail.vue?vue&type=template&id=70221611&scoped=true"
import script from "./accp-detail.vue?vue&type=script&lang=js"
export * from "./accp-detail.vue?vue&type=script&lang=js"
import style0 from "./accp-detail.vue?vue&type=style&index=0&id=70221611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70221611",
  null
  
)

export default component.exports